import { render, staticRenderFns } from "./related-product-list-item.component.vue?vue&type=template&id=4c5029bd&scoped=true"
import script from "./related-product-list-item.component.vue?vue&type=script&lang=ts"
export * from "./related-product-list-item.component.vue?vue&type=script&lang=ts"
import style0 from "./related-product-list-item.component.vue?vue&type=style&index=0&id=4c5029bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5029bd",
  null
  
)

export default component.exports